import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { getSelectedDate, getEarliestDate, getLatestDate, getStartDate, getEndDate, getDriftDates, getIsPeriodIntraday } from "modules/security-profile/selectors/dates"
import { computePositionSet } from "modules/security-profile/helpers/security"
import { getFilteredData, getDetails, getCategoryItemsSubset } from "./selectors/data"
import { getExposureAttributionData, getMaxFactors, getFirstHistoricalExposureDate, getSelectedCategory, getOptions } from "./selectors/exposure"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    driftDates: getDriftDates(state),
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    selectedDate: getSelectedDate(state),
    isPeriodIntraday: getIsPeriodIntraday(state, props),
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "securityContentSetHistory",
    url: ({ modelId, security: { assetClass, ticker, mic, modelProviderId }, base, contentSet, driftDates, startDate, endDate }) => {
      const from = startDate < driftDates.startDate ? startDate : driftDates.startDate
      const to = driftDates.endDate

      if (base) {
        if (!base.type) {
          base = {
            dates: [{
              date: from,
              ...base,
            }],
          }
        }
      }

      return {
        id: `securityContentSetHistory-${modelId}${contentSet}${ticker}${mic}${startDate}${endDate}${JSON.stringify(base)}`,
        query: `query ($modelId: String!, $contentSetId: String, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
          model (id: $modelId) {
            simulation(positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
              exposure (contentSetId: $contentSetId) {
                date
                factors { id name category net }
              }
            }
          }
        }`,
        variables: {
          modelId,
          contentSetId: contentSet,
          positionSet: {
            dates: [{
              date: startDate,
              ...computePositionSet(assetClass, ticker, mic, modelProviderId),
            }],
          },
          base,
          from,
          to,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    ...state.modules.securityProfileContentSet,
    earliestDate: getEarliestDate(state, props),
    latestDate: getLatestDate(state, props),
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    options: getOptions(state, props),
    details: getDetails(state, props),
    selectedCategory: getSelectedCategory(state, props),
    exposureAttribution: getExposureAttributionData(state, props),
    maxFactors: getMaxFactors(state, props),
    firstDate: getFirstHistoricalExposureDate(state, props),
  }),
  actions: {
    ...Creators,
    setDate: PortfolioRootCreators.setProfileDate,
    resetDate: PortfolioRootCreators.resetProfileDate,
  },
})
